import type { LucideIcon } from 'lucide-react'
import { ArrowRight } from 'lucide-react'
import { Link } from './nav'
import './TestingSetup.css'
import './SupportCard.css'

export type SupportStatus = { tone: 'red' | 'yellow' | 'gray' | 'white'; text: string; setup?: boolean }

export default function SupportCard({ title, icon: Icon, to, status }: {
  title: string; icon: LucideIcon; to: string; status: SupportStatus
}) {
  return <Link className={`testing-setup-card testing-setup-card--${status.tone}`} to={to}>
    <span className="testing-setup-card__icon"><Icon size={22} aria-hidden /></span>
    <span className="testing-setup-card__text"><strong>{title}</strong><span>{status.setup ? `Set up ${title}` : status.text}</span></span>
    <ArrowRight className="testing-setup-card__arrow" size={18} aria-hidden />
  </Link>
}
